export const Backend = process.env.REACT_APP_BACKEND_URL || `${window.location.protocol}//${window.location.hostname}:8010`;
export const apps = process.env.REACT_APP_APPS_URL || "http://localhost:8765";